import React from "react"
import OvertimeGame from "../Game/OvertimeGame"
import SxGame from "../Game/SxGame"

type SxUniqueEventsProps = {
  leagues: any
  showFilter?: boolean
}

const SxUniqueEvents: React.FC<SxUniqueEventsProps> = ({
  leagues,
  showFilter = false,
}) => {
  return (
    <div className="space-y-px">
      {leagues.map(({ countrySlug, slug, games }: any, leagueIndex: number) => {
        const leagueUrl = `/v2/unique/${countrySlug}/${slug}`

        return games.map((game: any, gameIndex: number) => (
          <SxGame
            key={`${leagueUrl}/${game.gameId}`}
            leagueUrl={leagueUrl}
            game={game}
            isUnique
            showFilter={showFilter}
            isFirstGame={leagueIndex === 0 && gameIndex === 0}
          />
        ))
      })}
    </div>
  )
}

export default SxUniqueEvents
